import React, { Component } from 'react';

import AdoptionCarousel from "./AdoptionCarousel";

import styleConstants from "../constants/styleConstants";
import renderSocials from "./common/RenderSocials";
import renderFooter from "./common/RenderFooter";
import {translate, getAdopteeInfoBlobByName, translatePageText} from "../i18n";


import adoptionBannerDefault from "../assets/images/banners/adoption-banner-default.png";
import adoptionBanner0 from "../assets/images/banners/adoption-banner-0.png";
import adoptionBanner1 from "../assets/images/banners/adoption-banner-1.png";
import adoptionBanner2 from "../assets/images/banners/adoption-banner-2.png";
import adoptionBanner3 from "../assets/images/banners/adoption-banner-3.png";
import infoConstants from "../constants/infoConstants";
import linkConstants from "../constants/linkConstants";



class Adoption extends Component {

    
    
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    //     onAdopteeClick
    //------------------------------------------
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/    
    onAdopteeClick = (name) => {

        // Update the current adoptee
        this.setState({currentAdopteeName: name});

    }//END onClickAdoptee
    
    
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    //     constructor
    //------------------------------------------
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    constructor(props) {

        super(props);

        this.state = {
            currentAdopteeName: "Douglas",
            bannerImages: [
                adoptionBanner0,
                adoptionBanner1,
                adoptionBanner2,
                adoptionBanner3
            ]
        };

    }//END constructor
    
    
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    //     getAdopteeInfo
    //------------------------------------------
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    getAdopteeInfo = (name) => {
        
        const adopteeBlob = getAdopteeInfoBlobByName(name);
        
        // TODO: Error checking around this
        // Fill in the image object
        adopteeBlob.bannerImage = this.state.bannerImages[adopteeBlob.id];
        
        return adopteeBlob;
        
    }//END getBannerImage
    
    
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    //     renderBanner
    //------------------------------------------
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    renderBanner() {

        const { currentAdopteeName } = this.state;
        const { bannerImage } = this.getAdopteeInfo(currentAdopteeName);
        
        return (
            <>
                <div className="banner-container">
                    <img
                        loading="lazy"
                        srcSet={bannerImage}
                        className="banner-img"
                    />
                    <div className="banner-title-text">{translatePageText('adoption', 'header', 'title')}</div>
                </div>
                <style jsx="true">{`
                    .banner-container {
                        display: flex;
                        flex-direction: column;
                        text-shadow: 0px 1px 16px rgba(0, 0, 0, 0.55);
                        position: relative;
                        width: 100%;
                        align-items: start;
                        overflow: hidden;
                        min-height: 557px;
                        color: #fff;
                        justify-content: center;
                        padding: 206px 60px 168px 87px;
                        font: 600 40px Work Sans, sans-serif;
                    }
                    @media (max-width: ${styleConstants.mobileScreenWidth}px) {
                        .banner-container {
                            max-width: 100%;
                            padding: 40px 20px 40px 30px;
                        }
                    }
                    .banner-img {
                        position: absolute;
                        inset: 0;
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                        object-position: center;
                    }
                    .banner-title-text {
                        position: absolute;
                        top: 25%;
                        right: 10%;
                        text-shadow: 0px 1px 16px rgba(0, 0, 0, 0.55);
                        color: #fff;
                        font: 600 40px Work Sans, sans-serif;
                    }
                    @media (max-width: ${styleConstants.mobileScreenWidth}px) {
                        .banner-title-text {
                            top: 25%;
                            left: 5%;
                        }
                    }
                    
                `}</style>
            </>
        );

    }//END renderBanner

    
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    //     renderDescription
    //------------------------------------------
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    renderDescription() {
        
        const { currentAdopteeName } = this.state;
        const { title, paragraph1, paragraph2, paragraph3 } = this.getAdopteeInfo(currentAdopteeName);
        
        return (
            <>
                <div className="cat-desc-container">
                    <div className="cat-title-text">{title}</div>
                    <br />
                    <br />
                    <div className="cat-reg-text">
                        {paragraph1}
                    </div>
                    <br />
                    <div className="cat-reg-text">
                        {paragraph2}
                    </div>
                    <br />
                    <div className="cat-reg-text">
                        {paragraph3}
                    </div>
                </div>
                <style jsx="true">{`
                .cat-desc-container {
                    color: var(--Neutral-600, #525b7a);
                    justify-content: center;
                    justify-items: center;
                    align-self: center;
                    align-content: center;
                    align-items: center;
                    margin-top: 72px;
                    margin-bottom: 48px;
                    padding: 0 104px 0 88px;
                    font: 400 16px Work Sans, sans-serif;
                }
                @media (max-width: ${styleConstants.mobileScreenWidth}px) {
                    .cat-desc-container {
                        padding: 0 64px 0 64px;
                    }
                }
                .cat-title-text {
                    color: var(--Neutral-900, #14171f);
                    font: 600 24px Work Sans, sans-serif;
                    align-self: center;
                    align-content: center;
                    width: 100%;
                }
                
                .cat-reg-text {
                    font: 400 16px Work Sans, sans-serif;
                    width: 100%;
                }
                
              `}</style>
            </>
        );
        
    }//END renderDescription


    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    //     renderAdoptionCallForAction
    //------------------------------------------
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    renderAdoptionCallForAction() {

        return (
            <>
                <div className="adapt-callforaction-container">
                    
                    <div className="adopt-callforaction-title">{translatePageText('adoption', 'paragraph1', 'title')}</div>
                    <div className="adopt-callforaction-text">

                        {translatePageText('adoption', 'paragraph1', 'text')}
                        <br/><br/>
                        
                        {translatePageText('adoption', 'paragraph2', 'text')}
                        <br/><br/>

                        {translatePageText('adoption', 'paragraph3', 'text')}
                        <br/>

                        {translatePageText('adoption', 'paragraph4', 'text')}
                        <br/><br/>

                        {translatePageText('adoption', 'paragraph5', 'text')}
                        <br /><br />
                        
                        {translatePageText('adoption', 'paragraph6', 'text')}
                        <br/><br/>
                        
                    </div>
                    
                    <iframe
                        title="Gracie's Adoption Form"
                        src={linkConstants.adoptionForm}
                        frameborder="0"
                        marginheight=""
                        marginwidth="0"
                        style={{ 
                            width: "100%", 
                            height: "2100px",
                            marginTop: "32",
                        }}
                    >
                        {translate('loading')}…
                    </iframe>                
                </div>
                    
                <br />
                <br />
                
                <style jsx="true">{`
                    
                .adapt-callforaction-container {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    //margin-top: 72px;
                    //padding: 0 104px 0 88px;
                    font: 400 16px Work Sans, sans-serif;
                }
                    
                .adopt-callforaction-title {
                  color: var(--Neutral-800, #292e3d);
                  text-align: center;
                  align-self: center;
                  margin-top: 63px;
                  font: 700 28px Work Sans, sans-serif;
                }
                @media (max-width: ${styleConstants.mobileScreenWidth}px) {
                  .adopt-callforaction-title {
                    margin-top: 40px;
                  }
                }
                .adopt-callforaction-text {
                    color: var(--Neutral-600, #525b7a);
                    text-align: left;
                    justify-content: center;
                    justify-items: center;
                    align-self: center;
                    align-content: center;
                    align-items: center;
                    margin-top: 15px;
                    //padding: 0 107px 0 73px;
                    width: 100%;
                    font: 400 16px Work Sans, sans-serif;
                }
                @media (max-width: ${styleConstants.mobileScreenWidth}px) {
                    .adopt-callforaction-text {
                        padding: 0px;
                        width: 80%;
                    }
                }
              `}</style>
            </>
        );
    
    }//END renderAdoptionCallForAction
    

    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    //     render
    //------------------------------------------
    /*~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~*/
    render() {

        return (
            <div>
                {this.renderBanner()}
                {this.renderAdoptionCallForAction()}
                
                {renderSocials()}
                {renderFooter()}
            </div>
        );

    }//END render


}//END class Landing


export default Adoption;
